import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect, useTransition } from 'react';
import { toast } from 'react-toastify';
// @mui
import { Stack, Button, Typography, Skeleton, Grid, Select, MenuItem, FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProjectTable } from '../sections/@dashboard/projects';
import Layout from '../components/Layout/Layout';
import SearchComponet from '../components/search/Search';

import { getProjectsList, deleteRegion } from '../network/apis';
import { hasPermission } from '../utils/permissions';
import { ReactComponent as DropdownIcon } from '../theme/images/deopdownIcon.svg';
import { resetFormData } from '../Store/features/projectForm/projectFormSlice';

export default function Projects() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [clientReqList, setClientReqList] = useState([]);
  const [search, setSearch] = useState('');
  const [status, setChangeStatus] = useState('');

  const handleChange = (e) => {
    setChangeStatus(e.target.value);
  };

  const clientRequests = (page, search, status) => {
    setLoading(true);
    getProjectsList(page, search, status)
      .then((res) => {
        setClientReqList(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    clientRequests(page, search, status);
  }, [page, search, status]);
  useEffect(() => {
    dispatch(resetFormData());
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleDelete = (id) => {
    deleteRegion(id)
      .then((res) => {
        if (res.data.STATUS === 'FAILED' || res.data.STATUS === '0') {
          toast.error(res.data.MESSAGE);
        } else toast.success(res.data.MESSAGE);
        // Reload the cities list
        clientRequests(page, search);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.MESSAGE);
      });
  };

  const handleOpenModal = () => {
    navigate('/dashboard/project/add');
  };
  const sideMenu = useSelector((state) => state.login?.sideMenu || []);
  const hasAddProjectPermission = hasPermission(sideMenu, '/dashboard/projects', 'Add Project');
  const hasViewProjectPermission = hasPermission(sideMenu, '/dashboard/projects', 'View Project Detail');
  const hasSearchProjectPermission = hasPermission(sideMenu, '/dashboard/projects', 'Search For Projects');
  const hasEditProjectPermission = hasPermission(sideMenu, '/dashboard/projects', 'Edit Project Detail');

  return (
    <>
      <Helmet>
        <title> {t('ManageProject.title')} </title>
      </Helmet>

      <Layout>
        <Grid marginBottom={1} display="flex" alignItems={'center'} justifyContent="space-between" md={6} xs={12}>
          <Typography sx={{ fontSize: '24px', fontWeight: '700', lineHeight: '32px', color: '#111827' }}>
            {t('ManageProject.title')}
          </Typography>
          {hasAddProjectPermission && (
            <Button
              onClick={handleOpenModal}
              style={{
                backgroundColor: 'black',
                color: 'white',
                borderRadius: '10px',
                padding: '21px 24px',
                width: '164px',
                height: '56px',
                display: 'flex',
                flexDirection: isRtl ? 'row-reverse' : 'row',
              }}
            >
              {' '}
              <Typography sx={{ display: 'flex', gap: 1, flexDirection: isRtl ? 'row-reverse' : 'row' }}>
                <span> + </span> <span>{t('ManageProject.addProject')}</span>
              </Typography>
            </Button>
          )}
        </Grid>
        <Grid mb={2} rowSpacing={2} container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          {hasSearchProjectPermission && (
            <Grid item xs={2} sm={4} md={4}>
              <SearchComponet onSearch={setSearch} style={{ width: '100%' }} />
            </Grid>
          )}

          <Grid item xs={2} sm={4} md={4}>
            <Grid item xs={2} sm={4} md={6}>
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  value={status}
                  sx={{
                    paddingX: '10px',
                    borderRadius: '10px',
                    flexDirection: 'row',
                    justifyContent: 'start',
                  }}
                  renderValue={(selected) => {
                    if (selected === '') {
                      return <span> {t('General.select')} </span>;
                    }
                    if (selected === 'TRUE') return t('General.Active');
                    if (selected === 'FALSE') return t('General.InActive');
                    return <span style={{ color: '#9e9e9e' }}>{t('General.AllStatus')}</span>;
                  }}
                  IconComponent={() => <DropdownIcon style={{ width: '15px', height: '15px' }} />}
                  labelId="Status"
                  id="status"
                  onChange={handleChange}
                >
                  <MenuItem value="">{t('General.AllStatus')}</MenuItem>
                  <MenuItem value="TRUE">{t('General.Active')}</MenuItem>
                  <MenuItem value="FALSE">{t('General.InActive')}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        {loading ? (
          <Stack>
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
            <Skeleton height={100} />
          </Stack>
        ) : (
          <>
            <>
              <ProjectTable
                handleChangePage={handleChangePage}
                page={page}
                requests={clientReqList}
                hasViewProjectPermission={hasViewProjectPermission}
                hasEditProjectPermission={hasEditProjectPermission}
                onDelete={handleDelete}
              />
            </>
          </>
        )}
      </Layout>
    </>
  );
}
